/* Copyright (c) Trimble Inc. All rights reserved. */
import {Box, Button, createStyles, DialogProps, Drawer, Link, makeStyles, TextField} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import {DialogActions, DialogContent, DialogTitle, IconButton} from "@material-ui/core";

import CloseIcon from "@material-ui/icons/Close";
import { IDropDownOption } from "modus/components/form/dropdown/Dropdown";

import { useAsyncAction } from "modus/components/form/async-actions/AsyncAction";

import { Alert } from "@material-ui/lab";
import { resolveAPIErrorMessage } from "modus/components/error-message/ErrorMessage";
import { useSelector } from "react-redux";
import { MY_TEAM_KEY } from "header/team-selector/TeamSelector";
import { INotification } from "./NotificationList.controller";
import TeamApprovalServices from "../services/TeamApprovalService";
import KVMViewer from "modus/components/misc/KVMViewer";
import { ConsentRejecter } from "./ConsentRejecter";
import { ConsentApprover } from "./ConsentApprover";
import TextArea from "legacy-components/general/textArea";
import { InputContainer } from "modus/components/form/input-container/InputContainer";
import ConsentService from "pages/home/applications/services/ConsentService";
import SVGFileViewer from "./SVGFileViewer";

interface NotificationActionsProps {
  notification: INotification;
  refreshApprovals : () => void
}
export const ConsentSummary: React.FC<NotificationActionsProps> = ({
  notification,
  refreshApprovals
}) => {
  const [open, setOpen] = React.useState(false);
  const commentsRef = React.useRef<HTMLInputElement>(null);
  const useStyles = makeStyles(() => {
    return createStyles({
      header: {
        position: "relative",
      },
      dialog: {
        overflowX: "hidden",
        width: '80vw', // Set the width of the dialog
      },
    });
  });

  const handleClickOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setOpen(true);
  };

  const handleClose = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setOpen(false);
  };


  const [comments, setComments] = useState<string>("");
  const teamId = useSelector((state: any) =>notification?.resource?.name ?? state?.teamManager?.teams?.currentTeam?.id ??sessionStorage.getItem(MY_TEAM_KEY));
  
  const { state, subscribe } = useAsyncAction(() =>
    TeamApprovalServices.approveTeamRequest(teamId, selectedValue.value, notification.requestedBy?.emailAddress ?? "")
  );

  const handleSubmit = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (state?.status !== "LOADING" && state?.status !== "LOADED") {
      subscribe();
    }
    setTimeout(() => {
      handleClose(event);
      refreshApprovals();
    }, 3000);
  };


  const [maxWidth] = useState<DialogProps["maxWidth"]>("sm");
  const style = useStyles();

  const defaultSelectorValue: IDropDownOption = {
    value: "user",
    title: "User",
  };
  const options: IDropDownOption[] = [
    { value: "user", title: "User", optType: "itemBody" },
    { value: "admin", title: "Admin", optType: "itemBody" },
  ];

  const [selectedValue, setSelectedValue] =
    useState<IDropDownOption>(defaultSelectorValue);
  const handleOnSelect = (value: string) => {
    setSelectedValue(
      options.find((option) => option.value === value) || defaultSelectorValue
    );
  };

   const { subscribe: getConsentDetails, state: consentState } = useAsyncAction(() => ConsentService.getConsent(notification?.resource?.id as string));
  
    useEffect(() => {
      if (notification?.resource?.id) {
        getConsentDetails();
      }
    }, [notification?.resource, getConsentDetails]);



  const [response, setResponse] = useState({
    applicationName: notification?.resource?.name,
    requestedBy: notification?.requestedBy,
    applicationLogo: notification?.resource?.applicationLogo,
    privacyPolicy: notification?.resource?.privacyPolicy,
    termsOfService: notification?.resource?.termsOfService,
  });

  useEffect(() => {
    if( !notification?.resource || !consentState?.value) {
      return;
    }
    if (consentState?.status === "LOADED" && consentState?.value) {
      setResponse({
        applicationName: notification?.resource?.name,
        requestedBy: notification?.requestedBy,
        applicationLogo: consentState.value.applicationLogo,
        privacyPolicy: consentState.value.privacyPolicyUrl,
        termsOfService: consentState.value.termsOfServiceUrl,
      });
    } else if (consentState?.status === "ERROR") {
      console.error('Error fetching consent state:', consentState.error);
    }
  }, [consentState, setResponse]);
;
  return (
    <>
      <Button color="primary" variant="outlined" onClick={handleClickOpen}>
        Review
      </Button>
      <Drawer
        anchor="right"  
        style={{width:'80vw'}}
        open={open}
        onClose={handleClose}
        onClick={(event: React.MouseEvent<HTMLDivElement>) => event.stopPropagation()}
        classes={{
          paper: style.dialog,
        }}
      >
        <DialogTitle>
          Review User Consent Request
          <IconButton
            aria-label="close"
            onClick={handleClose}
            style={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {state?.error && state?.status === "LOADED" && (
            <Alert severity="error">
              {resolveAPIErrorMessage(state?.error)}
            </Alert>
          )}
          {!state?.error && state?.status === "LOADED" && (
            <Alert severity="success">{`${notification?.requestedBy?.name} is now the member of ${notification?.requestedBy?.team} team.`}</Alert>
          )}
          <KVMViewer
            //title="Consent Summary"
            dataList={{
              "Application Name": response?.applicationName,
              // "Account Name": response?.requestedBy?.accountName,
              // "Application Logo": <SVGFileViewer url={response?.applicationLogo} />,
              "Contact Email": response?.requestedBy?.emailAddress,
              "Privacy Policy": (<Link className="link" target="_blank" href={response?.privacyPolicy} > {response?.privacyPolicy} </Link>),
              "Terms of Service": (<Link className="link" target="_blank" href={response?.termsOfService} > {response?.termsOfService} </Link>),

            } as any}
          
          />
         
         
         <InputContainer
             label="Comments"
            placeholder="Add your comments"
            rowsMax={6}
            rows={6}
            required={false}
            style={{ width: "100%" }}
            multiline
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setComments(event.target.value);
            }}
            value={comments}
          />
          
        </DialogContent>
        <DialogActions>
          <Box p={2} display="flex" flexDirection="row" justifyContent="flex-end">
            
            {notification?.resource?.id && (<ConsentRejecter reason={comments} reloadNotificationList={refreshApprovals} resourceId={notification.resource.id}/>)}
            <Box ml={2}/>
            {notification?.resource?.id && (<ConsentApprover reloadNotificationList={refreshApprovals} resourceId={notification.resource.id}/>)}
          </Box>
        </DialogActions>
      </Drawer>
    </>
  );
};

export default ConsentSummary;
